import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { MailIcon, ArrowRightIcon, ArrowLeftIcon } from 'lucide-react';
interface ForgotPasswordProps {
  navigate: (screen: string, param?: string) => void;
}
export function ForgotPassword({
  navigate
}: ForgotPasswordProps) {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    // Simulate API call
    setTimeout(() => {
      setIsLoading(false);
      navigate('otp-verification', 'reset');
    }, 1500);
  };
  return <div className="flex-1 bg-slate-50 flex flex-col h-full relative overflow-hidden" data-id="element-1673">
      {/* Header Background */}
      <div className="absolute top-0 left-0 right-0 h-80 bg-[#FFD700] rounded-b-[3rem]" data-id="element-1674" />

      {/* Content */}
      <div className="flex-1 flex flex-col px-6 pt-12 pb-safe z-10 overflow-y-auto" data-id="element-1675">
        {/* Back Button */}
        <button onClick={() => navigate('login')} className="w-10 h-10 bg-white/40 backdrop-blur-md rounded-full flex items-center justify-center mb-6 shadow-sm" data-id="element-1676">
          <ArrowLeftIcon className="w-5 h-5 text-[#0D3B3B]" data-id="element-1677" />
        </button>

        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="flex flex-col items-center mb-10" data-id="element-1678">
          <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center shadow-lg mb-6" data-id="element-1679">
            <MailIcon className="w-8 h-8 text-[#0D3B3B]" data-id="element-1680" />
          </div>
          <h1 className="text-3xl font-black text-[#0D3B3B] mb-2 text-center" data-id="element-1681">
            Forgot Password
          </h1>
          <p className="text-[#0D3B3B]/70 text-sm text-center max-w-[260px] font-medium" data-id="element-1682">
            Enter your email or phone number to receive a 4-digit reset code.
          </p>
        </motion.div>

        {/* Form */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="bg-white rounded-[2rem] p-6 shadow-xl shadow-[#0D3B3B]/5 flex flex-col max-w-md w-full mx-auto" data-id="element-1683">
          <form onSubmit={handleSubmit} className="flex flex-col" data-id="element-1684">
            <div className="space-y-1.5 mb-8" data-id="element-1685">
              <label className="text-xs font-bold text-gray-500 uppercase tracking-wider ml-1" data-id="element-1686">
                Email or Phone
              </label>
              <div className="relative flex items-center" data-id="element-1687">
                <div className="absolute left-4 text-gray-400" data-id="element-1688">
                  <MailIcon className="w-5 h-5" data-id="element-1689" />
                </div>
                <input type="text" value={email} onChange={e => setEmail(e.target.value)} placeholder="Enter your email or phone" className="w-full bg-gray-50 border border-gray-200 rounded-2xl py-4 pl-12 pr-4 text-sm font-medium text-[#0D3B3B] focus:outline-none focus:ring-2 focus:ring-[#2BA89D]/20 focus:border-[#2BA89D] transition-all placeholder-gray-400" required data-id="element-1690" />
              </div>
            </div>

            <button type="submit" disabled={isLoading || !email} className={`w-full py-4 rounded-2xl font-bold text-lg flex items-center justify-center gap-2 transition-all active:scale-95 ${isLoading || !email ? 'bg-gray-100 text-gray-400 cursor-not-allowed' : 'bg-[#0D3B3B] text-white hover:bg-[#092D2D] shadow-lg shadow-[#0D3B3B]/20'}`} data-id="element-1691">
              {isLoading ? <div className="w-6 h-6 border-2 border-white/30 border-t-white rounded-full animate-spin" data-id="element-1692" /> : <>
                  Send Reset Code
                  <ArrowRightIcon className="w-5 h-5" data-id="element-1693" />
                </>}
            </button>
          </form>
        </motion.div>
      </div>
    </div>;
}